import React from "react";
import RecordPage from "../../components/RecordPage";
import { useApp } from "../../core/AppContext";
import { formatDate, todayIso } from "../../core/format";
import { letterPrint } from "../../core/printConfigs";

export default function Letters() {
  const { meta } = useApp();
  const dirs = Object.entries(meta?.letterDirections || {}).map(([value, label]) => ({ value, label }));
  return (
    <RecordPage  printReport={letterPrint} title="نامه‌نگاری" subtitle="ثبت و بایگانی نامه‌های وارده، صادره و داخلی" endpoint="/letters" multipart createLabel="ثبت نامه"
      canCreate canEdit canDelete initial={{ direction: "outgoing", letterDate: todayIso() }}
      filters={[{ name: "direction", label: "نوع نامه", options: dirs }]}
      columns={[
        { key: "letterNo", label: "شماره", render: (r) => <b dir="ltr">{r.letterNo}</b> },
        { key: "letterDate", label: "تاریخ", render: (r) => formatDate(r.letterDate) },
        { key: "direction", label: "نوع", render: (r) => <span className="badge wait">{meta?.letterDirections?.[r.direction]}</span> },
        { key: "subject", label: "موضوع", render: (r) => <div className="clip" title={r.subject}>{r.subject}</div> },
        { key: "sender", label: "فرستنده" },
        { key: "recipient", label: "گیرنده" },
      ]}
      fields={[
        { name: "direction", label: "نوع نامه", type: "select", options: dirs, required: true },
        { name: "letterNo", label: "شماره نامه", hint: "خالی بگذارید تا خودکار ساخته شود", ltr: true },
        { name: "letterDate", label: "تاریخ نامه", type: "date", required: true, full: true },
        { name: "subject", label: "موضوع", required: true, full: true },
        { name: "sender", label: "فرستنده", required: true },
        { name: "recipient", label: "گیرنده", required: true },
        { name: "body", label: "متن نامه", type: "textarea" },
        { name: "file", label: "تصویر / فایل نامه (اختیاری)", type: "file", full: true },
      ]} />
  );
}
